import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import { LocalString, Plural, Money } from 'translate-react';

import { togglePanel, resetDate } from '../actions';



let TimeColumns = (props, context) => {
	let { open, calendar } = props;
	let { togglePanel, resetDate } = props;

	let { selecting, selectionStart, selectionEnd, selectionStartHover, selectionEndHover } = calendar;

	let start = null, end = null;
	if ( selectionStart || selectionStartHover ) {
		start = moment(selectionStart || selectionStartHover);
	}
	if ( selectionEnd || selectionEndHover ) {
		end = moment(selectionEnd || selectionEndHover);
	}

	let startClass = "accordion-col accordion-col1 " + ( (!selectionStart && !selectionStartHover) || (open && !selecting) ? "active" : "");
	let endClass = "accordion-col accordion-col2 " + ( selectionStartHover ? "active" : "");

	return (
		<div style={{height:'100%'}}>
			<div className={startClass}>
				<span><LocalString word="Anreise" /></span>
				<strong>{ start ? start.format("dd. DD. MMMM YYYY") : <LocalString word="Bitte auswählen" /> }</strong>
			</div>
			<div className={endClass}>
				<span><LocalString word="Abreise" /></span>
				<strong>{ end ? end.format("dd. DD. MMMM YYYY") : <LocalString word="Bitte auswählen" /> }</strong>
			</div>
			<div className="accordion-col accordion-col3">
				<span><LocalString word="Zeitraum" /></span>
				<strong>{ end || calendar.nights ? <Plural word="nights" amount={calendar.nights} /> : <LocalString word="Bitte auswählen" /> }</strong>
			</div>
			<div className="accordion-col accordion-col4">
				{selectionStart && open ?
				<button onClick={(e) => resetDate()} className="reset-btn">
					<LocalString word="Zurücksetzen" />
				</button>
				: null}
				{!open ? 
				<button onClick={(e) => togglePanel("date")}>
					<LocalString word="Ändern" />
				</button>
				: null}
			</div>
		</div>
	);
};


const mapStateToProps = (state) => ({
    calendar: state.calendar,
})

const mapDispatchToProps = (dispatch) => ({
	togglePanel: panel => dispatch(togglePanel(panel)),
	resetDate: _ => dispatch(resetDate()),
})

export default connect(mapStateToProps, mapDispatchToProps)(TimeColumns);




/** WEBPACK FOOTER **
 ** ../ibe/desktop/TimeColumns.js
 **/